/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService, Logger, LogService } from '@epg/angular-base-lib';
import { getActiveTenantFromSessionStorage } from '../../app/shared/functions';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  deletedFiles: string[] = [];

  apiEndPoint: string;
  private log: Logger;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logService: LogService
  ) {
    this.log = this.logService.getLogger(this);

    try {
      this.apiEndPoint = this.appConfig.getParameter('BlobServiceEndPoint') as string;
    } catch {
      this.log.debug('No API Endpoint defined!');
      this.apiEndPoint = '';
    }
  }

  public sendFormData(formData: FormData) {
    return this.http.post<any>(this.apiEndPoint, formData, {
      headers: this.getHeaders()
    });
  }
  public getFileData(id: string) {
    return this.http.get<any>(this.apiEndPoint + '/' + id, {
      headers: this.getHeaders()
    });
  }
  public deleteFile(id: string) {
    return this.http.delete<any>(this.apiEndPoint + '/' + id, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const tenant = getActiveTenantFromSessionStorage();
    const headers = new HttpHeaders({
      'x-Tenant-Id': `${tenant ? tenant.toLowerCase() : undefined}`,
      Accept: 'application/json'
    });
    return headers;
  }
}
